// extracted by mini-css-extract-plugin
export default {"ScreenMLMin":"(min-width: 1025px)","fixedMobileCTAContainer":"G93e64a"};